import moment from 'moment/moment';
import { isTournamentPool } from '../../Football/Common/Common';
import { isLocalMeeting } from '../../Common/home-common';
import { IsPassBetlinesValidFn } from '../../BetSlip/BetlinesValidFunc';
import { getWebIDHashed } from './adobeLaunch';

export const getAddToBetSlipAdobeEventData = ({ newBets, passValidBets, acceptBetSlipLength, source }, t, i18n) => {
    try {
        let eCommerceBetslips = [];
        const newPassValidBets = passValidBets.slice(-acceptBetSlipLength);
        newBets.slice(-acceptBetSlipLength).forEach((betItem, index) => {
            const category = getECommerceCategory(betItem);
            let newBettingMethod = '';
            if (betItem.prod === 'FB') {
                const { betType, matchInfo, betList } = betItem.betObj;
                const isALUP = betType.includes('ALUP');
                const isPreEvent = !matchInfo || matchInfo?.status == 'PREEVENT';

                if (source?.type === 'panelAlupTemplate') {
                    newBettingMethod = 'AllUpBuilder-Add';
                } else if (isALUP) {
                    const mixBetlineBettingMethods = betList.map((i) => {
                        if (!i.matchInfo || i.matchInfo?.status == 'PREEVENT') {
                            return 'PreEvent';
                        } else {
                            return 'Inplay';
                        }
                    });
                    const hasPreEvent = mixBetlineBettingMethods.includes('PreEvent');
                    const hasInplay = mixBetlineBettingMethods.includes('Inplay');
                    if (hasPreEvent && hasInplay) {
                        newBettingMethod = 'NA';
                    } else if (hasPreEvent) {
                        newBettingMethod = 'PreEvent';
                    } else {
                        newBettingMethod = 'Inplay';
                    }
                } else if (isPreEvent) {
                    newBettingMethod = 'PreEvent';
                } else {
                    newBettingMethod = 'Inplay';
                }
            } else if (betItem.prod === 'HR') {
                const { betType, subType } = betItem.betObj;
                if (source?.type === 'raceSim') {
                    newBettingMethod = `RacingSimulator-${source.mode}`;
                } else if (source?.type === 'panelAlupTemplate') {
                    newBettingMethod = 'AllUpBuilder-Add';
                } else if (betType === 'TCE') {
                    newBettingMethod = i18n.exists(`LB_STYPE_${subType}`)
                        ? t(`LB_STYPE_${subType}`, {
                              lng: 'en'
                          })
                        : '';
                } else {
                    newBettingMethod = betItem.betObj.bettingMethod;
                }
            } else {
                newBettingMethod = getM6BettingMethod(betItem);
            }
            betItem.betObj.bettingMethod = newBettingMethod;
            eCommerceBetslips.push({
                id: getECommerceId(betItem, t),
                category,
                betting_method: newBettingMethod,
                betline: newPassValidBets[index].betline,
                amount: getBetLineAmount(betItem),
                source: betItem.betObj.bettingSource
            });
        });
        return {
            event: 'eWin_AddToBetslip',
            interaction: { eventID: 'AddToBetslip' },
            report_suite: 'HKJC web',
            eCommerce: {
                eCommerceCat: 'eWin',
                betslips: eCommerceBetslips
            }
        };
    } catch (error) {
        console.warn(`[getAddToBetSlipAdobeEventData error]`, error);
        return null;
    }
};

const getECommerceId = (betItem,  t) => {
    let eCommerceId = '';
    if (betItem.prod === 'FB') {
        const { betType, frontEndId, selectedFormula, tournamentNameEN, betList, matchInfo, tournInfo, combs } =
            betItem.betObj;
        const isALUP = betType.includes('ALUP');
        const matchDate = moment(matchInfo?.kickOffTime).format('DD/MM/YYYY');
        const betTypeName = t(`LB_FB_TITLE_${betType}`, { lng: 'en' }).replace("\n", "");
        if (betType === 'SGA') {
            eCommerceId = `Football-Allup-SameGameAllUp-${matchDate}-${frontEndId}`;
        } else if (isALUP) {
            const frontEndIds = betList.map(item => item.frontEndId).join('::');
            const productDates = betList.map(item => {
                const productDate = item.matchInfo ? item.matchInfo.kickOffTime : item.combs[0]?.currentPool?.expectedSuspendDateTime;
                return moment(productDate).format('DD/MM/YYYY')
            }).join('::');
            eCommerceId = `Football-Allup-${selectedFormula}-${productDates}-${frontEndIds}`;
        } else if (isTournamentPool(betType)) {
            const expectedSuspendDateTime = moment(combs[0]?.currentPool?.expectedSuspendDateTime).format('DD/MM/YYYY');
            eCommerceId = `Football-Single-${betTypeName}-${expectedSuspendDateTime}-${tournamentNameEN}`;
        } else {
            eCommerceId = `Football-Single-${betTypeName}-${matchDate}-${frontEndId}`;
        }
    } else if (betItem.prod === 'HR') {
        const { allupFormula, venueid, meetingDate, raceno, betType, betList } = betItem.betObj;
        const isAllUp = [...window.racingConfig?.ALUP_PAGE, 'CWAALLALUP'].includes(betType) || allupFormula;
        const raceDay = moment(meetingDate).format('DD/MM/YYYY');
        const betTypeName = t(`LB_${betType}`, { lng: 'en' });

        if (isLocalMeeting(venueid)) {
            if (isAllUp) {
                const raceNos = betList.map((item) => `R${item.raceNo}`).join('::');
                eCommerceId = `Racing-Allup-${allupFormula}-${raceDay}-${raceNos}`;
            } else if ([...window.racingConfig?.FO_PAGE].includes(betType)) {
                eCommerceId = `Racing-Single-${betTypeName}-${raceDay}`;
            } else {
                const curRaceNo = raceno || betList?.[0].raceNo;
                eCommerceId = `Racing-Single-${betTypeName}-${raceDay}-R${curRaceNo}`;
            }
        } else {
            const curVenueid = venueid || '';
            if (isAllUp) {
                const raceNos = betList.map((item) => `${curVenueid}_R${item.raceNo}`).join('::');
                eCommerceId = `Racing-Allup-${allupFormula}-${raceDay}-${raceNos}`;
            } else {
                const curRaceNo = raceno || betList?.[0].raceNo;
                eCommerceId = `Racing-Single-${betTypeName}-${raceDay}-${curVenueid}_R${curRaceNo}`;
            }
        }
    } else {
        const { nextDraw } = betItem.betObj;
        const drawDate = moment(nextDraw.closeDate).format('DD/MM/YYYY');
        const nextDrawNo = nextDraw?.id ? `${nextDraw.year.substring(2,4)}/${String(nextDraw?.no).padStart(3, '0')}` : '-';
        eCommerceId = `Marksix-Single-${getM6BetType(betItem)}-${drawDate}-${nextDrawNo}`;
    }
    return eCommerceId;
};

const getM6BetType = (betItem) => {
    const { bankerList, random, numList } = betItem.betObj;
    if (random) {
        return 'QuickPick';
    }

    if (bankerList?.length > 0) {
        return 'Banker';
    }

    if (numList?.length > 6) {
        return 'Multiple';
    }

    return 'Single';
};

const getM6BettingMethod = (betItem) => {
    const { pageName, random } = betItem.betObj;
    if (random && pageName != "EWINHOME") {
        return ['RANDOM', 'RANDOMSNOWBALL'].includes(pageName) ? 'QuickPick' : 'Quickpick-Autofill';
    }
};

const getECommerceCategory = (betItem) => {
    return betItem.prod === 'FB' ? 'Football' : betItem.prod === 'HR' ? 'Racing' : 'Marksix';
};

export const getDeleteBetSlipAdobeEventData = (deleteBets, t) => {
    try {
        let eCommerceBetSlips = [];
        const deletePassValidBets = IsPassBetlinesValidFn(deleteBets).passBets;
        deleteBets.forEach((betItem, index) => {
            const category = getECommerceCategory(betItem);
            eCommerceBetSlips.push({
                id: getECommerceId(betItem, t),
                category,
                betting_method: betItem.betObj.bettingMethod,
                betline: deletePassValidBets[index].betline,
                amount: getBetLineAmount(betItem),
                source: betItem.betObj.bettingSource
            });
        });
        return {
            event: 'eWin_DeleteBetslip',
            interaction: { eventID: 'DeleteBetslip' },
            report_suite: 'HKJC web',
            eCommerce: {
                eCommerceCat: 'eWin',
                betslips: eCommerceBetSlips
            }
        };
    } catch (error) {
        console.warn(`[getDeleteBetSlipAdobeEventData error]`, error);
        return null;
    }
};

const getBetLineAmount = (item, isCounterOfferAmountChangeOnConfirmationPage) => {
    const unitBet = isCounterOfferAmountChangeOnConfirmationPage ? item.oldUnitBet : item.unitBet;
    if (item.prod === 'FB' && item.betObj.betType === 'ALUP') {
        return item.betObj.noOfComb * unitBet;
    } else if (item.prod === 'HR') {
        if (item.betObj.isFlexi && item.betObj.betTotal) {
            return parseInt(item.betObj.betTotal);
        } else {
            return item.betObj.noOfBets * unitBet;
        }
    } else {
        const multidraw = item.betObj.multidraw ? item.betObj.multidraw : 1;
        return item.betObj.noOfBets * unitBet * multidraw;
    }
};

export const getTransactionPreviewBetSlipAdobeEventData = (previewDisplayBets, t) => {
    try {
        let eCommerceBetSlips = [];
        const previewPassValidBets = IsPassBetlinesValidFn(previewDisplayBets).passBets;
        previewDisplayBets.forEach((betItem, index) => {
            eCommerceBetSlips.push({
                id: getECommerceId(betItem, t),
                category: getECommerceCategory(betItem),
                betting_method: betItem.betObj.bettingMethod,
                betline: previewPassValidBets[index].betline,
                amount: getBetLineAmount(betItem),
                source: betItem.betObj.bettingSource
            });
        });

        return {
            event: 'eWin_Transaction_PreviewBetslip',
            interaction: { eventID: 'Transaction_PreviewBetslip' },
            report_suite: 'HKJC web',
            eCommerce: {
                eCommerceCat: 'eWin',
                betslips: eCommerceBetSlips
            }
        };
    } catch (error) {
        console.warn(`[getTransactionPreviewBetSlipAdobeEventData error]`, error);
        return null;
    }
};

export const getTransactionBetResultAdobeEventData = (sendBetLines, confirmationStatus, t) => {
    try {
        const { status, unknown } = confirmationStatus;
        if (status === 'unknown' && sendBetLines.length === unknown) {
            return null;
        }

        let eCommerceBetSlips = [];
        sendBetLines.forEach((betItem) => {
            let bettingMethod = betItem.betObj.bettingMethod;
            if (betItem.isCounterOffer) {
                if (betItem.counterOfferOddsChange && betItem.counterOfferAmountChange) {
                    bettingMethod = bettingMethod
                        ? `${bettingMethod}::ResendRejectOdds::ResendRejectAmtLimit`
                        : 'ResendRejectOdds::ResendRejectAmtLimit';
                } else if (betItem.counterOfferOddsChange) {
                    bettingMethod = bettingMethod ? `${bettingMethod}::ResendRejectOdds` : 'ResendRejectOdds';
                } else {
                    bettingMethod = bettingMethod ? `${bettingMethod}::ResendRejectAmtLimit` : 'ResendRejectAmtLimit';
                }
            }

            const isUnknown = !betItem?.resultCode && betItem?.resultCode !== 0;
            const isAccepted = betItem?.resultCode === 0 && !betItem.isCounterOffer;
            if (!isUnknown) {
                let currentECommerce = {
                    id: getECommerceId(betItem, t),
                    status: isAccepted ? 'accept' : 'reject',
                    category: getECommerceCategory(betItem),
                    betting_method: bettingMethod,
                    betline: betItem.betLineStr,
                    amount: getBetLineAmount(betItem, betItem.isCounterOffer && betItem.counterOfferAmountChange),
                    source: betItem.betObj.bettingSource
                };

                if (!isAccepted) {
                    currentECommerce.reject_reason = betItem.resultMsg;
                }

                eCommerceBetSlips.push(currentECommerce);
            }
        });

        const cuno = getWebIDHashed() || '';
        const unixTimestamp = Math.floor(Date.now() / 1000);

        return {
            event: 'eWin_Transaction_BetResult',
            interaction: { eventID: 'Transaction_BetResult' },
            report_suite: 'HKJC web',
            eCommerce: {
                eCommerceCat: 'eWin',
                betslips: eCommerceBetSlips,
                purchaseID: `${cuno.slice(-9)}${unixTimestamp}`
            }
        };
    } catch (error) {
        console.warn(`[getTransactionBetResultAdobeEventData error]`, error);
        return null;
    }
};
